<script>
import axios from 'axios'

function httpHookInit () {
  // Intercept the request to make sure the token is injected into the header.
  axios.interceptors.request.use(config => {
    if (!window._httpGrovalHookEnabled) {
      return config
    }
    config.headers['x-jm1service-auth'] = this.$store.getters.token
    return config
  })
  axios.interceptors.response.use(response => {
    if (!window._httpGrovalHookEnabled) {
      window._httpGrovalHookEnabled = true
      return response
    }
    // console.log(
    //   'httpHookInit:axios.interceptors.response response=' + JSON.stringify(response))
    // console.log('store.getters=' + JSON.stringify(store.getters))
    // status code は 200 でもレスポンスの result が -401 ならログアウトする
    if (response.data.result === -401) {
      const user = this.$store.getters.user
      if (!user || !user.username) {
        // https://aplix.backlog.com/view/HARPS-301
        // username が無いのに他の情報が中途半端に残っているとトラブルの元なので消す
        this.$store.dispatch('logout')
        return response
      }
      const username = user.username
      const refreshToken = this.$store.getters.refreshToken
      let originalRequest = response.config
      if (!originalRequest._retry) {
        // 再帰侵入防止
        originalRequest._retry = true
        // console.log('httpHookInit: -401 handling...dispatch refreshSession')
        return this.$store.dispatch('refreshSession', {username, refreshToken})
        .then(() => {
          console.log('httpHookInit: -401 handling...dispatch refreshSession done try again')
          return axios(response.config)
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('logout') // ログアウト処理を呼び出す
          this.$store.commit('SET_MESSAGE', {
            title: '',
            message: 'You need to login.',
            level: 'error'
          })
          this.$router.push('/login') // ログイン画面へ
        })
      } else {
        console.log('httpHookInit:_retry is true: continue')
      }
    }
    return response
  }, error => {
    // エラー時の共通処理
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      // 403 は message をセットして、その先の動作は呼び出し元が扱う
      if (error.response.status === 403 && window._httpGrovalHookEnabled) {
        this.$store.commit('SET_MESSAGE', {
          title: '',
          message: 'You don\'t have permissoin.',
          level: 'error'
        })
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
    }
    if (!window._httpGrovalHookEnabled) {
      window._httpGrovalHookEnabled = true
    }
    return Promise.reject(error)
  })
}

export default {
  install (Vue) {
    window._httpGrovalHookEnabled = true
    Vue.prototype.$httpHookInit = function () {
      return httpHookInit.apply(this)
    }
  }
}
</script>


// WEBPACK FOOTER //
// HttpHook.vue?0ada02fe